// import { CalendarDays } from "lucide-react";
import { Helper, Label } from "lumir-back-office-ui";
import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";
import { Radio } from "../../../../../components/atoms/radio/radio";
import { useFormContext } from "react-hook-form";
import { InputField } from "./inputField";
import { MidLabel } from "./midLabel";
import { SelectBox } from "./selectBox";
import { useEffect } from "react";
import useDisplay from "../../../../../hooks/useDisplay";

const formatPhoneNumber = (value) => {
  if (!value) return "";
  const numbers = value.replace(/[^0-9]/g, "");
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 7) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(
    7,
    11
  )}`;
};

const ApplyBasicInfo = ({ name, accessRoutes }) => {
  const { isMobile, isTablet } = useDisplay();

  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();

  const experience = watch(`${name}.experience`);
  const isNew = experience?.isNew ?? true;

  useEffect(() => {
    if (experience?.isNew) {
      setValue(`${name}.experience.years`, 0);
      setValue(`${name}.experience.label`, "신입");
    }
  }, []);

  const handleExperienceChange = (value) => {
    setValue(`${name}.experience.isNew`, value);
    if (!value) {
      setValue(`${name}.experience.years`, 1);
      setValue(`${name}.experience.label`, "경력");
    } else {
      setValue(`${name}.experience.years`, 0);
      setValue(`${name}.experience.label`, "신입");
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    const formattedValue = formatPhoneNumber(value);
    setValue(`${name}.phone`, formattedValue);
  };

  return (
    <section>
      <TextDisplay
        size="lg"
        textData={{
          primary: "지원자 정보",
        }}
        className="mb-[32px]"
      />
      <section className="space-y-[16px] mb-[40px]">
        <MidLabel label="기본 정보" required />
        <InputField
          label="이름"
          placeholder="김철수"
          {...register(`${name}.name`, { required: false })}
          error={errors[name]?.name?.message}
        />
        <InputField
          label="이메일"
          placeholder="example@gmail.com"
          {...register(`${name}.email`)}
          error={errors[name]?.email?.message}
        />
        <InputField
          label="전화번호"
          placeholder="010-1234-5678"
          {...register(`${name}.phone`, {
            onChange: handlePhoneChange,
            maxLength: 13,
          })}
          error={errors[name]?.phone?.message}
        />
        <SelectBox
          label="지원경로"
          placeholder="지원 경로 선택"
          contents={accessRoutes}
          contentClassName={
            isMobile
              ? "w-[calc(100vw-40px)]"
              : isTablet
              ? "w-[672px]"
              : "w-[720px]"
          }
          {...register(`${name}.applyPath`)}
          error={errors[name]?.applyPath?.message}
        />
        {/* <InputField
          label="생년월일"
          placeholder="2024.12.27"
          type="date"
          rightIcon={
            <CalendarDays className="text-semantic-secondary-foreground-strong-default w-[20px] h-[20px] pr-[2px]" />
          }
          {...register(`${name}.birthDate`)}
          error={errors[name]?.birthDate?.message}
        /> */}
      </section>
      <section>
        <MidLabel label="경력사항" required />
        <div className="space-y-8 mb-4 mt-8">
          <div className="flex items-center space-x-4">
            <Radio
              checked={isNew}
              onChange={() => handleExperienceChange(true)}
              className="custom-cursor"
              id={`${name}-new`}
            />
            <Label
              htmlFor={`${name}-new`}
              className="custom-cursor cursor-none"
            >
              신입
            </Label>
          </div>
          <div className="flex items-center space-x-8">
            <div className="flex items-center space-x-4 mt-2">
              <Radio
                checked={!isNew}
                onChange={() => handleExperienceChange(false)}
                className="custom-cursor"
                id={`${name}-experienced`}
              />
              <Label
                htmlFor={`${name}-experienced`}
                className="custom-cursor cursor-none"
              >
                경력
              </Label>
            </div>
            <div className="w-[120px]">
              <SelectBox
                placeholder="1년"
                contents={Array.from({ length: 30 }, (_, i) => ({
                  id: i + 1,
                  name: `${i + 1}년`,
                }))}
                contentClassName="w-[120px]"
                {...register(`${name}.experience.years`)}
                disabled={isNew}
              />
            </div>
          </div>
        </div>
        {errors[name]?.experience?.years && (
          <Helper
            size="md"
            state="error"
            className="typography-semantic-body-2-regular"
            message={errors[name].experience.years.message}
          />
        )}
      </section>
    </section>
  );
};

export { ApplyBasicInfo };
